import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router'; // Ensure 'react-router' matches your version

const AffiliateLogin = () => {
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const res = await fetch(`${import.meta.env.VITE_API_URL}/affiliate/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });

            const data = await res.json();

            if (res.ok) {
                // Store token specifically for affiliate
                localStorage.setItem('affiliateToken', data.token);
                // Redirect to affiliate dashboard
                navigate('/affiliate/dashboard');
            } else {
                alert(data.message || "Login failed");
            }
        } catch (error) {
            console.error(error);
            alert("Network error. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-900 text-gray-100 p-4">
            <div className="bg-gray-800 p-8 rounded-xl shadow-2xl w-full max-w-md border border-gray-700">
                <div className="text-center mb-8">
                    <h1 className="text-3xl font-bold text-blue-500 mb-2">Partner Portal</h1>
                    <p className="text-gray-400 text-sm">Login to track your earnings & referrals</p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label className="block text-xs font-bold text-gray-500 uppercase mb-2">Email Address</label>
                        <input 
                            type="email" 
                            className="w-full p-3 bg-gray-700 rounded border border-gray-600 text-white focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none transition" 
                            placeholder="partner@example.com" 
                            onChange={e => setFormData({...formData, email: e.target.value})} 
                            required 
                        />
                    </div>

                    <div>
                        <label className="block text-xs font-bold text-gray-500 uppercase mb-2">Password</label>
                        <input 
                            type="password" 
                            className="w-full p-3 bg-gray-700 rounded border border-gray-600 text-white focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none transition" 
                            placeholder="••••••••" 
                            onChange={e => setFormData({...formData, password: e.target.value})} 
                            required 
                        />
                    </div>

                    <button 
                        type="submit" 
                        disabled={loading}
                        className={`w-full py-3 rounded-lg font-bold text-white transition transform hover:-translate-y-0.5 shadow-lg ${loading ? 'bg-gray-600 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'}`}
                    >
                        {loading ? 'Logging In...' : 'Access Dashboard'}
                    </button>
                </form>

                <div className="mt-6 text-center pt-6 border-t border-gray-700">
                    <p className="text-sm text-gray-400">
                        New partner? <Link to="/affiliate/register" className="text-blue-400 hover:text-blue-300 font-semibold hover:underline">Join Program</Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AffiliateLogin;